/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import MapBoxGL from 'mapbox-gl';
import PropTypes from '../util/prop_types';
import { MapSelectors } from '../stores/map_selectors';
import { MapActionCreators } from '../stores/map_action_creators';
import { SidePanelSelectors } from '../stores/sidepanel_selectors';
import Marker from './marker';
import SearchPin from './search_pin';

const mapStateToProps = (state) => {
  return {
    viewport: MapSelectors.getViewport(state),
    markerHoverId: MapSelectors.getMarkerHoverId(state),
    searchResults: SidePanelSelectors.getSearchResultsPage(state),
  }
}

const mapDispatchToProps = {
  setPopup: MapActionCreators.setPopup,
};

class MapSearchMarkers extends React.Component {
  constructor(props) {
    super(props);
    this.noZoom = false;
  }

  static propTypes = {
    viewport: PropTypes.immutable.map.isRequired,
    markerHoverId: PropTypes.number,
    searchResults: PropTypes.immutable.map.isRequired,
  }

  static contextTypes = {
    map: PropTypes.object,
  }

  componentWillReceiveProps(nextProps) {
    this.noZoom = (nextProps.searchResults == this.props.searchResults);
  }

  componentWillUnmount() {
    if(this._zoomTimeout) {
      clearTimeout(this._zoomTimeout);
    }
  }

  _renderSearchMarkers = () => {
    const { searchResults, markerHoverId } = this.props;
    const startItem = searchResults.get('start');
    var markerGeos = [];

    const markers = searchResults.get('results').map((result, i) => {
      var id = startItem + i;

      const color = (markerHoverId == id) ?  '#58A618' : '#035642';
      const geometry = result.item.geometry.coordinates;

      const clickHandler = (feature) => {
        this.props.setPopup(geometry[0], geometry[1], result.item);
      };

      //add to geo calc for fit to
      markerGeos.push(result.item.geometry);

      return (
        <Marker key={`marker-${id}`}
          longitude={geometry[0]}
          latitude={geometry[1]}
          offsetLeft={-20}
          offsetTop={-40} >
          <SearchPin
            backgroundColor={color}
            onClick={clickHandler} />
        </Marker>
      );
    });

    // zoom to markers after 1 second
    if (!this.noZoom) {
      if(this._zoomTimeout) {
        clearTimeout(this._zoomTimeout);
      }
      this._zoomTimeout = setTimeout(() => {
        var bounds = new MapBoxGL.LngLatBounds();
        var options = {
          padding: 30,
          linear: true,
          maxZoom: this.props.viewport.get('zoom').first(),
        };
        if (window.innerWidth >= 600) {
          options.offset = [240, 0];
        }

        for(var i = 0, len = markerGeos.length; i < len; i++) {
            bounds.extend(markerGeos[i].coordinates);
        }

        this.context.map.fitBounds(bounds, options);
      }, 1000);
    }

    return markers;
  }

  render(): ?React.Element<any> {
    return (
      <div>
        {!this.props.searchResults.isEmpty() &&
          this._renderSearchMarkers()
        }
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MapSearchMarkers);
